<div class="flex justify-center mt-2" style="height: 70%;">
    <ag-grid-angular style="width: 100%;" class="ag-theme-alpine"
        [columnDefs]="treatmentColumnDefs" [defaultColDef]="defaultColDef" [rowData]="treatmentData"
        [gridOptions]="gridOptions">
    </ag-grid-angular>
</div>